import { render, staticRenderFns } from "./AddDashboardURL.vue?vue&type=template&id=4f5d2231&scoped=true"
import script from "./AddDashboardURL.vue?vue&type=script&lang=js"
export * from "./AddDashboardURL.vue?vue&type=script&lang=js"
import style0 from "./AddDashboardURL.vue?vue&type=style&index=0&id=4f5d2231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d2231",
  null
  
)

export default component.exports